<template>
    <div class="modal-content">
        <div class="modal-header p-b-0">
			<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            <h4 class="modal-title" id="myLargeModalLabel">Verifique seu Número Celular</h4>
		</div>

        <div class="modal-body">
            <vue-simple-spinner class="m-t-30" v-if="step == 0" message="Carregando..."></vue-simple-spinner>
            <div v-if="step == 1">
                <p><strong>Verifique seu número de celular abaixo para prosseguir.</strong></p>

                <div class="row m-t-20">
                    <div class="col-xs-12">
                        <div class="form-group" v-bind:class="{'has-error': errors.has('cellphone')}">
                            <label for="cellphone" class="control-label">Celular</label>
                            <input id="cellphone" class="form-control" v-validate="'required'" name="cellphone" v-mask="['(##) ####-####', '(##) #####-####']" v-model="cellphone" type="tel">
                            <span class="help-block" v-show="errors.has('cellphone')">
                                <strong>{{ errors.first('cellphone') }}</strong>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="row m-t-20">
                    <div class="col-xs-12">
                        <button id="btn_sms" @click="sendMsg()" class="btn btn-custom w-lg waves-effect waves-light ladda-buton">
                            <span class="ladda-label">Enviar SMS</span>
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="step == 2">
                <p><strong>Enviamos um código de verificação por sms para seu celular.
                    Preencha o código no campo abaixo. Nunca compartilhe este código com ninguém!</strong></p>
                <div class="row m-t-20">
                    <div class="col-xs-12">
                        <div class="form-group" v-bind:class="{'has-error': errors.has('mobile_code')}">
                            <label class="control-label" for="mobile_code">Código de Verificação</label>
                            <input type="text" class="form-control" name="mobile_code" v-model="verification_code" required />
                            <span class="help-block text-left" v-show="errors.has('mobile_code')">
                                <strong>{{ errors.first('mobile_code') }}</strong>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="row m-t-20">
                    <div class="col-xs-12">
                        <button @click="verifyCode()" :disabled="!verification_code" class="btn btn-custom w-lg waves-effect waves-light ladda-button">
                            <span class="ladda-label">Verificar</span>
                        </button>
                    </div>
                </div>

                <hr/>

                <p>Não recebeu o código em seu celular?
                    <a @click.prevent="goBack()" class="btn-link" :class="{ 'disabled-link': !canResend }" href="#">
                        {{ canResend ? `Reenviar SMS.` : `Reenviar em ${countdown}s` }}
                    </a>
                </p>
            </div>

            <div v-if="step == 3">
                <p class="m-t-30 text-center"><img src="/images/positive.png" width="126" alt="" /></p>
                <p class="text-center m-t-15"><b>Excelente!</b> Seu número de celular foi verificado com sucesso.</p>
                <div class="text-center m-t-40 m-b-30">
                    <button @click="closeModal()" class="btn btn-custom w-lg waves-effect waves-light">Concluir</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mask} from '../../../../../../legacy/node_modules/vue-the-mask';
import Spinner from '../../../../../../legacy/node_modules/vue-simple-spinner';

export default {
    props: ['number'],
    data: function () {
        return {
            cellphone: this.number,
            retry: false,
            verification_code: null,
            step: 1,
            countdown: 0,
            canResend: false,
        }
    },
    methods: {
        closeModal: function () {
            this.$emit('close-modal');
        },
        goBack: function() {
            this.step = 1;
            this.retry = !this.retry;
        },
        sendMsg: function () {
            this.$validator.validateAll().then((res) => {
                if (res === false) {
                    return;
                }
                
                this.step = 0;
                this.startCountDown();
                
                axios.post('/user/send-mobile-verification', { cellphone: this.cellphone, retry: this.retry }).then(() => {
                    this.step = 2;
                }).catch(function() {
                    this.step = 1;
                    this.$validator.errors.add({
                        field: "cellphone",
                        msg: 'Não conseguimos enviar o código de verificação para este número. Por favor, atualize a página e tente novamente.'
                    });
                });
            });
        },
        verifyCode: function () {
            this.step = 0;
            
            axios.post('/user/verify-mobile', { code: this.verification_code }).then((res) => {
                if (res.data.response) {
                    this.step = 3;
                } else {
                    this.step = 2;
                    this.$validator.errors.add({
                        field: 'mobile_code',
                        msg: 'Não foi possível verificar o código informado. Confirme se preencheu corretamente o código recebido por SMS.'
                    });
                }
            }).catch(() => {
                this.step = 2;
                this.$validator.errors.add({
                    field: 'mobile_code',
                    msg: 'Não foi possível verificar este código. Por favor, atualize a página e tente novamente.'
                });
            })
        },
        startCountDown() {
            this.countdown = 30;
            this.canResend = false;

            const interval = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(interval);
                    this.canResend = true;
                }
            }, 1000);
        }
    },
    created: function () {
        const dictionary = {
            messages: {
                required: () => 'Este campo é obrigatório!',
            }
        };
        this.$validator.localize('pt_BR', dictionary);
    }
}
</script>

<style lang="scss">
    .modal-header {
        border-bottom: none !important;
    }
    .profile_img {
        width: 54px;
    }
    .disabled-link {
        pointer-events: none;
        cursor: not-allowed;
    }
</style>
